import React, { useMemo, useState } from 'react';
import { Dropdown, Menu, Image, Modal, Form, Button } from 'semantic-ui-react';
import { Images } from '../../assets/assets';
import { endpoint, POST } from '../../api/http';
import { onWarning } from '../shared/messages';
import IFrameDialog from '../shared/iframedialog';
import HotelsDropDown from '../shared/HotelsDropDown';
import UsersDropDown from '../shared/UsersDropDown';
import { useTextResources } from '../../language';

const UserMenu = ({
    user,
    isAdmin,
    recordScreen,
    onFinishRecording,
    OnLogoutClicked
}) => {
    const text = useTextResources();
    const [switchHotelSettings, setSwitchHotelSettings] = useState({
        HotelId: user.DefaultHotelID,
        ChainId: user.HotelChainId,
        UserId: user.Id
    });
    const [switching, setSwitching] = useState(false);
    const [switchChainOpen, setSwitchChainOpen] = useState(false);

    const chainsSpec = useMemo(() => {
        return {
            HotelsForAllChains: true,
            IsActive: true,
            includes: ["HotelChain"],
            MaxResults: 10000,
            UserGroupPermittedForLogin: '777777'
        }
    }, []);

    const usersSpec = useMemo(() => {
        return {
            ChainId: switchHotelSettings.ChainId,
            DefaultHotelID: switchHotelSettings.HotelId,
            SpecificSystemRole: 1, //SILVERBYTEADMINISTRATOR
            UserGroupPermittedForLogin: '777777'
        }
    }, [switchHotelSettings]);

    const switchToHotel = async () => {
        setSwitching(true)
        try {
            const result = await POST('Organization/Account/InitiateSwitchChainMfa', {
                HotelId: switchHotelSettings.HotelId,
                ChainId: switchHotelSettings.ChainId,
                UserId: switchHotelSettings.UserId
            })

            if (result.twoFactorNotEnabled) {
                onWarning(text('TwoFactorNotEnabledForSwitchChain'))
                setSwitching(false)
                return
            }

            if (result.success && result.mfaToken) {
                setSwitchChainOpen(false)
                const basePath = endpoint.endsWith('/') ? endpoint : endpoint + '/'
                window.location = `${basePath}Organization/Account/TwoFactor?mfaToken=${encodeURIComponent(result.mfaToken)}&phone=${encodeURIComponent(result.phone || '')}`
                return
            }

            onWarning(text('SwitchChainFailed'))
            setSwitching(false)
        } catch (err) {
            onWarning(err?.error || err?.message || text('SwitchChainFailed'))
            setSwitching(false)
        }
    };

    return (
        <>
            <Dropdown simple item trigger={
                <div>
                    <Image src={Images.login_avatar} avatar size="mini" />
                    <span style={{ verticalAlign: "middle" }}>{user.UserName}</span>
                </div>
            }>
                <Dropdown.Menu>
                    <Menu.Item link href={`${endpoint}Organization/User/Edit?isUserProfile=true&userID=${user.Id}`}>{text("Profile")}</Menu.Item>
                    <IFrameDialog trigger={
                        <Menu.Item>{text("Chat")}</Menu.Item>
                    } size="mini" title="Chat" src="https://tawk.to/chat/5db156ae78ab74187a5b4986/default" />
                    <IFrameDialog trigger={
                        <Menu.Item>{text("Updates")}</Menu.Item>
                    } size="fullscreen" title="Updates" src="https://www.silverselfie.com/he/optima-2020-new-update/" />
                    <Menu.Item link onClick={()=>{recordScreen(onFinishRecording)}}>{text("RecordScreenMenu")}</Menu.Item>
                    <Dropdown.Divider />
                    {isAdmin && user.UserSettings?.[0]?.UserGroupPermittedForLogin === '666666' &&
                        <Menu.Item onClick={() => setSwitchChainOpen(true)}>{text("SwitchChain")}</Menu.Item>}
                    <Menu.Item link href={`${endpoint}Organization/Account/LogOut`} onClick={OnLogoutClicked}>{text("LogOut")}</Menu.Item>
                </Dropdown.Menu>
            </Dropdown>
            {isAdmin && user.UserSettings?.[0]?.UserGroupPermittedForLogin === '666666' &&
                <Modal size="small" open={switchChainOpen} onClose={() => setSwitchChainOpen(false)}>
                    <Modal.Header>{text("SwitchChain")}</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field search label={text("SelectHotel")} control={HotelsDropDown}
                                    value={switchHotelSettings.HotelId} onChangeItem={item => {
                                        setSwitchHotelSettings({
                                            ...switchHotelSettings,
                                            HotelId: item?.Id,
                                            ChainId: item?.HotelChainId,
                                            UserId: null
                                        })
                                    }} spec={chainsSpec}
                                    descriptionField={hotel => {
                                        return hotel.HotelChain.Name
                                    }} />
                                <Form.Field search label={text("SelectUser")} control={UsersDropDown}
                                    value={switchHotelSettings.UserId} onChange={value => {
                                        setSwitchHotelSettings({
                                            ...switchHotelSettings,
                                            UserId: value
                                        })
                                    }} spec={usersSpec} selectFirst={options => {
                                        return options.find(o => o.text.toLowerCase().startsWith("support"))
                                    }}
                                    descriptionField={user => {
                                        return user.Email
                                    }} />
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button disabled={!(switchHotelSettings.ChainId && switchHotelSettings.UserId) || switching} loading={switching} positive onClick={switchToHotel}>{text("Switch")}</Button>
                    </Modal.Actions>
                </Modal>}
        </>
    );
};

export default UserMenu;
